import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Button } from '../../components/ui/button';
import { Shield } from 'lucide-react';

const AdminLoginScreen = ({ password, setPassword, onSubmit, loading }) => (
  <div className="min-h-screen bg-gray-900 pt-16 flex items-center justify-center">
    <Card className="max-w-md w-full mx-4 bg-gray-800 border-gray-700">
      <CardHeader className="text-center">
        <div className="mx-auto w-12 h-12 bg-purple-600 rounded-full flex items-center justify-center mb-4">
          <Shield className="w-6 h-6 text-white" />
        </div>
        <CardTitle className="text-white text-2xl">Admin Access</CardTitle>
        <CardDescription className="text-gray-400">Enter the admin password to manage users</CardDescription>
      </CardHeader>
      <CardContent>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="password" className="text-gray-300">
              Admin Password
            </Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter admin password"
              className="bg-gray-700 border-gray-600 text-white placeholder:text-gray-500"
              required
              data-testid="admin-password-input"
            />
          </div>
          <Button
            type="submit"
            className="w-full bg-purple-600 hover:bg-purple-700 text-white"
            disabled={loading}
            data-testid="admin-login-btn"
          >
            {loading ? 'Authenticating...' : 'Login'}
          </Button>
        </form>
      </CardContent>
    </Card>
  </div>
);

export default AdminLoginScreen;
